import { DateFormats, formatDate } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { DetailLabel, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { ReferralStatusIndicator } from '@strata/react-status-indicators';
import PropTypes from 'prop-types';

import { RTAReferralStatusIndicator } from 'components/referralHistory/RTAReferralStatusIndicator';
import { usePlaceOfServiceList } from 'services/APIHooks';

export const ReferralDetails = ({ selectedReferral = undefined, referralDetails = undefined }) => {
    const placeOfServiceList = usePlaceOfServiceList();

    return (
        <FormSectionWithRows
            sectionTitle="Referral Details"
            width="75%"
            isLoading={!referralDetails}
            rowOneContent={
                <>
                    <div style={{ width: '25%' }}>
                        <DetailLabel label="Referral Status" />
                        <RTAReferralStatusIndicator
                            referralStatus={selectedReferral?.referralStatus}
                            supplierName={selectedReferral?.supplierName}
                            supplierPhone={selectedReferral?.supplierPhone}
                        />
                    </div>
                    <DetailLabelValuePair
                        style={{ width: '25%' }}
                        label="Prescriber Name"
                        value={referralDetails?.prescriberName}
                    />
                    <DetailLabelValuePair
                        style={{ width: '25%' }}
                        label="Place Of Service"
                        value={
                            placeOfServiceList?.find(
                                (option) => option.code === referralDetails?.placeOfService,
                            )?.name
                        }
                    />
                    <DetailLabelValuePair
                        style={{ width: '25%' }}
                        label="Needs By Date"
                        value={formatDate(referralDetails?.clinicalInfo?.needsByDate)}
                    />
                </>
            }
            rowTwoContent={
                <>
                    <DetailLabelValuePair
                        style={{ width: '25%' }}
                        label="Submitted By"
                        value={referralDetails?.submittedBy}
                    />
                    <DetailLabelValuePair
                        style={{ width: '25%' }}
                        label="Submitted At"
                        value={formatDate(referralDetails?.submittedAt, DateFormats.DATE_TIME)}
                    />
                    <DetailLabelValuePair
                        style={{ width: '25%' }}
                        label="Referral Expiration"
                        value={formatDate(referralDetails?.referralExpiration)}
                    />
                    <DetailLabelValuePair
                        style={{ width: '25%' }}
                        label="Referral ID"
                        value={referralDetails?.friendlyId}
                    />
                </>
            }
        />
    );
};

ReferralDetails.propTypes = {
    selectedReferral: PropTypes.shape({
        referralStatus: PropTypes.oneOf(Object.values(ReferralStatusIndicator.Statuses)),
        supplierName: PropTypes.string,
        supplierPhone: PropTypes.string,
    }),
    referralDetails: PropTypes.shape({
        prescriberName: PropTypes.string,
        placeOfService: PropTypes.string,
        clinicalInfo: PropTypes.shape({
            needsByDate: PropTypes.string,
        }),
        referralExpiration: PropTypes.string,
        referralId: PropTypes.string,
        submittedBy: PropTypes.string,
        submittedAt: PropTypes.string,
        friendlyId: PropTypes.string,
    }),
};
